exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".merchant-badge h3 {\n  display: none; }\n\n.merchant-badge h2 {\n  font-weight: 100;\n  display: inline;\n  margin-left: 20px; }\n\n.merchant-badge img {\n  float: left;\n  max-height: 60px;\n  max-width: 200px;\n  margin-left: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/common/components/MerchantBadge/style.scss
// module id = 1024
// module chunks = 0